$(window).load(function(){
    
    $('.subFeaturesItemImage').each(function(){
        var container_height = $(this).height();
        var image_height = $('img', this).height();
        var top_margin = (container_height - image_height)/2;
        $('img',this).css( 'margin-top' , top_margin).fadeIn('fast');
        $(this).css('background', '#FFFFFF');
    });   
    
    $('.collectionItemImage').each(function(){
        var container_height = $(this).height();
        var image_height = $('img', this).height();
        var top_margin = (container_height - image_height)/2;
        $('img',this).css( 'margin-top' , top_margin).fadeIn('fast');
        $(this).css('background', '#FFFFFF');
    });
    
});